var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.6665C16.6604 3.6776 17.7402 3.76602 18.4445 4.47037C19.25 5.27582 19.25 6.57219 19.25 9.16491V14.6649C19.25 17.2576 19.25 18.554 18.4445 19.3595C17.6391 20.1649 16.3427 20.1649 13.75 20.1649H8.25C5.65728 20.1649 4.36091 20.1649 3.55546 19.3595C2.75 18.554 2.75 17.2576 2.75 14.6649V9.16491C2.75 6.57219 2.75 5.27582 3.55546 4.47037C4.25981 3.76602 5.33956 3.6776 7.33333 3.6665",
    stroke: "#949494",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.2835L9.82143 13.7502L13.75 10.0835",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 3.2085C7.3335 2.4491 7.9491 1.8335 8.7085 1.8335H13.2918C14.0512 1.8335 14.6668 2.4491 14.6668 3.2085V4.12516C14.6668 4.88455 14.0512 5.50016 13.2918 5.50016H8.7085C7.9491 5.50016 7.3335 4.88455 7.3335 4.12516V3.2085Z",
    stroke: "#949494",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpList);
export default __webpack_public_path__ + "static/media/emp-list.7684e9fd2c5328065a7dc712824f610e.svg";
export { ForwardRef as ReactComponent };